var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "content-class": "image-dialog" },
      on: { input: _vm.onBackgroundClicked },
      model: {
        value: _vm.assetUrl,
        callback: function($$v) {
          _vm.assetUrl = $$v
        },
        expression: "assetUrl"
      }
    },
    [
      _vm.isImage
        ? _c("img", {
            staticClass: "lightbox-image",
            attrs: { src: _vm.assetUrl, "align-center": "" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isPdf
        ? _c("embed", {
            staticClass: "lightbox-pdf",
            attrs: {
              src: _vm.assetUrl,
              "align-center": "",
              height: _vm.windowHeight - 200
            }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1440c6a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1440c6a5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lightbox.vue
// module id = null
// module chunks = 